import { useEffect, useState } from 'react';

/**
 * Mounts children after first paint (idle / short timeout) so homepage LCP
 * is not blocked by Firebase presence, pageview writes, or Phi identify.
 */
export default function DeferredBoot({ children, timeoutMs = 2200 }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let idleId;
    let timerId;
    const go = () => setReady(true);

    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
      idleId = window.requestIdleCallback(go, { timeout: timeoutMs });
    } else {
      timerId = window.setTimeout(go, Math.min(timeoutMs, 800));
    }

    return () => {
      if (idleId != null && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleId);
      }
      if (timerId != null) window.clearTimeout(timerId);
    };
  }, [timeoutMs]);

  if (!ready) return null;
  return children;
}
